// src/routes/ask/index.tsx
// /ask — redirects to /agent (canvas-only cleanup).
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/ask/')({
  beforeLoad: () => {
    throw redirect({ to: '/agent', replace: true, search: { q: undefined } })
  },
})
